(function (root) {
  'use strict';
  const order = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  const normalizeSize = (s) => {
    const value = String(s).trim().toUpperCase().replace(/[-_\s]+/g, ' ');
    return ({ 'EXTRA SMALL': 'XS', 'SMALL': 'S', 'MEDIUM': 'M', 'LARGE': 'L', 'EXTRA LARGE': 'XL', 'XXL': '2XL', 'XXXL': '3XL' })[value] || value;
  };
  const richText = (n) => typeof n === 'string' ? n : !n ? '' : (n.value || '') + (n.children || []).map(richText).join('') + (['paragraph', 'list-item', 'heading'].includes(n.type) ? '\n' : '');
  const fieldName = (label) => {
    const s = label.toLowerCase().replace(/[^a-z]/g, '');
    if (/chest|bust/.test(s) || s === 'bodywidth') return 'chest';
    if (s === 'shoulder' || s === 'shoulderwidth') return 'shoulder';
    if (s === 'sleeve' || s === 'sleevelength') return 'sleeve';
    if (/shouldersleeve|raglan|sleevefromneck/.test(s)) return 'shoulderSleeve';
    if (/waist/.test(s)) return 'waist';
    if (/hip|seat/.test(s)) return 'hip';
    if (['length', 'bodylength', 'backlength', 'back', 'body', 'pantslength', 'pants', 'outseam', 'coatlength'].includes(s)) return 'length';
    return null;
  };
  function parseCell(label, value) {
    const s = String(value).toLowerCase().replace(/(\d),(\d)/g, '$1.$2');
    const pattern = /(\d+(?:\.\d+)?)(?:\s*[-–~]\s*(\d+(?:\.\d+)?))?\s*(cm|inches|inch|in\b|″|")/g;
    const matches = [...s.matchAll(pattern)];
    if (!matches.length || /not applicable|n\/a/.test(s)) return null;
    const cm = matches.find(m => m[3] === 'cm');
    const inches = matches.find(m => m[3] !== 'cm');
    const m = cm || inches;
    const factor = cm ? 1 : 2.54;
    const min = Number(m[1]) * factor;
    const max = Number(m[2] || m[1]) * factor;
    const mismatch = cm && inches && (Math.abs(min - Number(inches[1]) * 2.54) > 0.6 || Math.abs(max - Number(inches[2] || inches[1]) * 2.54) > 0.6);
    return { min, max, label, half: /width|half|flat|pit.to.pit/i.test(label), mismatch: Boolean(mismatch) };
  }
  function parseChart(text, sizes) {
    const chart = {};
    let size = null;
    const known = sizes.map(normalizeSize);
    String(text).split(/\r?\n/).map(s => s.trim()).filter(Boolean).forEach(line => {
      const normalized = normalizeSize(line.replace(/^size\s*:?\s*/i, ''));
      if (known.includes(normalized)) { size = normalized; chart[size] ||= {}; return; }
      if (!size) return;
      const sep = line.indexOf(':');
      if (sep < 0) return;
      const label = line.slice(0, sep);
      const field = fieldName(label);
      if (!field) return;
      const cell = parseCell(label, line.slice(sep + 1));
      if (cell) {
        if (chart[size][field] && Math.abs(chart[size][field].min - cell.min) > 0.6) cell.conflict = true;
        chart[size][field] = cell;
      }
    });
    return chart;
  }
  function profile(config) {
    const text = `${config.productTitle} ${config.description}`.toLowerCase();
    const oversized = /\boversiz(?:e|ed)\s+(?:fit|silhouette|shape|cut)|\boversized\b[^.!?]{0,20}\b(?:blazer|coat|jacket)\b/.test(text);
    const fit = oversized ? 'oversized' : /compact fit|slim fit|close.fitting|held close/.test(text) ? 'slim' : /boxy fit/.test(text) ? 'boxy' : /relaxed fit|wide.?leg/.test(text) ? 'relaxed' : 'regular';
    const bottom = /pants|trouser|jeans|shorts|skirt/.test(config.productType.toLowerCase());
    const outerwear = /jacket|blazer|coat|trench|down/.test(config.productType.toLowerCase());
    const flexibleWaist = /elastic(?:ated)?(?:[ -]back)?[ -]waist|half.elastic[ -]waist|elasticated back|drawstring[ -]waist|adjustable[ -]waist/.test(text);
    const stretch = /stretch|elastane|spandex|rib.knit|rib tank/.test(text);
    return { fit, bottom, outerwear, flexibleWaist, stretch, text };
  }
  const circumference = c => c ? c.min * (c.half ? 2 : 1) : null;
  const reviewedChestWidths = {"5pm-oversized-blazer": {"S": 62.0, "M": 64.0, "L": 66.0}, "that-ll-do-jacket": {"S": 78.0, "M": 80.0, "L": 82.0}, "short-notice-jacket": {"S": 67.0, "M": 69.0, "L": 71.0}, "high-collar-utility-jacket": {"S": 72.0, "M": 74.0, "L": 76.0}, "longline-blazer": {"S": 53.0, "M": 57.0, "L": 61.0}, "not-quite-sweater": {"S": 64.0, "M": 66.0, "L": 68.0}, "just-in-case-field-jacket": {"S": 71.0, "M": 73.0, "L": 75.0}, "padded-zip-jacket": {"S": 71.0, "M": 73.0, "L": 75.0}, "outline-wool-coat": {"S": 67.0, "M": 69.0, "L": 71.0}, "grid-check-blazer": {"S": 63.0, "M": 65.0, "L": 67.0}, "cropped-cardigan-01": {"S": 55.0, "M": 57.0, "L": 59.0}, "too-ready-down-vest": {"S": 68.5, "M": 70.5, "L": 72.5, "XL": 74.5}};
  function normalizeChartBasis(config, source) {
    const chart = Object.fromEntries(Object.entries(source).map(([size, row]) => [size, Object.fromEntries(Object.entries(row).map(([field, cell]) => [field, { ...cell }]))]));
    const expected = reviewedChestWidths[config.productHandle];
    if (expected && Object.keys(expected).length === Object.keys(chart).length && Object.entries(expected).every(([size, width]) => chart[size]?.chest?.min === width && chart[size].chest.max === width)) {
      Object.values(chart).forEach(row => { row.chest.half = true; });
    }
    return chart;
  }
  function reviewedLargeChest(config, chart) {
    return config.productHandle === 'held-together-strap-coat' && Object.keys(chart).length === 3 && ['S','M','L'].every((size, i) => chart[size]?.chest?.min === 192 + i * 4 && chart[size].chest.max === 192 + i * 4 && !chart[size].chest.half);
  }
  function audit(config, chart) {
    chart = normalizeChartBasis(config, chart);
    const p = profile(config);
    const sizes = [...new Set(config.sizes.map(normalizeSize))].sort((a, b) => order.indexOf(a) - order.indexOf(b));
    const excluded = /shoe|sneaker|bag|gift|protection/i.test(config.productType) || /do my job|\btest product\b/i.test(config.productTitle) || sizes.every(s => ['F', 'ONE SIZE', 'OS'].includes(s));
    if (excluded) return { excluded: true, issues: [], sizes, profile: p };
    const issues = [];
    if (config.productHandle === 'outline-wool-coat' && ['S','M','L'].every((size, i) => chart[size]?.length?.min === 71 + i * 2 && chart[size]?.chest?.min === 67 + i * 2)) issues.push('source_chart_review');
    if (!sizes.length || sizes.some(s => !order.includes(s))) issues.push('unsupported_sizes');
    const main = p.bottom ? 'waist' : 'chest';
    sizes.forEach((size, i) => {
      const row = chart[size] || {};
      for (const field of [main, 'length']) if (!row[field]) issues.push(`${size}:missing_${field}`);
      for (const [field, c] of Object.entries(row)) {
        if (c.mismatch || c.conflict || c.min <= 0 || c.max < c.min) issues.push(`${size}:${field}:invalid`);
        const value = ['chest','waist','hip'].includes(field) ? circumference(c) : c.min;
        if (field === 'chest' && !c.half && value < 90 && p.fit !== 'slim' && !/rib tank/i.test(config.productTitle)) issues.push(`${size}:chest_basis_unconfirmed`);
        if (field === 'chest' && ((value > 180 && !reviewedLargeChest(config, chart)) || value < 65)) issues.push(`${size}:chest_review`);
        if (field === 'waist' && (value < 55 || value > 180)) issues.push(`${size}:waist_basis_unconfirmed`);
        if (field === 'length' && (value < 20 || value > 160)) issues.push(`${size}:length_review`);
        const prev = chart[sizes[i - 1]]?.[field];
        if (prev) {
          const previous = ['chest','waist','hip'].includes(field) ? circumference(prev) : prev.min;
          if (value < previous - 0.6 || (field === 'length' && value - previous > 8 && !(config.productHandle === 'no-forecast-trench' && sizes.join(',') === 'S,M' && Math.abs(chart.S.length.min - 125) < 0.1 && Math.abs(chart.M.length.min - 145) < 0.1))) issues.push(`${size}:${field}:grading_review`);
        }
      }
    });
    return { issues: [...new Set(issues)], sizes, profile: p, excluded: false };
  }
  function referenceSize(input) {
    const equivalentWeight = input.weight * Math.pow(178 / input.height, 2);
    const knots = [48, 56, 65, 75, 86, 98, 112, 128, 146];
    let position = 0;
    if (equivalentWeight >= knots[knots.length - 1]) position = knots.length - 1;
    else for (let i = 0; i < knots.length - 1; i++) {
      if (equivalentWeight >= knots[i] && equivalentWeight < knots[i + 1]) {
        position = i + (equivalentWeight - knots[i]) / (knots[i + 1] - knots[i]);
        break;
      }
    }
    return { position, chest: 82 + position * 6, waist: 64 + position * 6, hip: 84 + position * 5 };
  }
  function recommend(config, chart, input) {
    chart = normalizeChartBasis(config, chart);
    const check = audit(config, chart);
    const p = check.profile;
    const fail = (status, reason, extra = {}) => ({ status, reason, sizes: [], ...extra });
    if (check.excluded) return fail('excluded', 'excluded');
    if (check.issues.length) return fail('review', 'chart_review', { issues: check.issues });
    if (!Number.isFinite(input.height) || input.height < 140 || input.height > 220 || !Number.isFinite(input.weight) || input.weight < 40 || input.weight > 180) return fail('input', 'invalid_body');
    for (const f of ['chest', 'waist', 'hip']) if (input[f] != null && (!Number.isFinite(input[f]) || input[f] < 55 || input[f] > 180)) return fail('input', 'invalid_measurement', { field: f });
    if (input.maxLength != null && (!Number.isFinite(input.maxLength) || input.maxLength < 20 || input.maxLength > 160)) return fail('input', 'invalid_length', { field: 'maxLength' });
    const main = p.bottom ? 'waist' : 'chest';
    const measured = input[main] != null;
    const reference = referenceSize(input);
    const body = measured ? input[main] : reference[main];
    const long = p.bottom ? !/shorts/.test(config.productType.toLowerCase()) : check.sizes.some(s => chart[s].length.min >= 100);
    const longCoat = !p.bottom && long;
    const middleSize = check.sizes[Math.floor((check.sizes.length - 1) / 2)];
    const designedEase = Math.max(24, circumference(chart[middleSize].chest) - (82 + order.indexOf(middleSize) * 6));
    const target = p.bottom ? 2 : p.fit === 'oversized' ? designedEase : ({ slim: 4, regular: 10, relaxed: 16, boxy: 14 })[p.fit];
    const minimum = p.bottom ? 0 : p.outerwear ? 10 : p.fit === 'slim' ? 0 : 4;
    const preference = p.fit === 'oversized' ? 0 : input.preferredFit === 'relaxed' ? 0.25 : input.preferredFit === 'close' ? -0.25 : 0;
    const buildShift = measured ? 0 : ({ slim: -0.25, average: 0, broad: 0.25 })[input.build] || 0;
    const usualIndex = order.indexOf(normalizeSize(input.usualSize || ''));
    const usualShift = measured || usualIndex < 0 ? 0 : Math.max(-1, Math.min(1, usualIndex - reference.position)) * 0.15;
    const auxiliaryPosition = reference.position + buildShift + usualShift + preference;
    const runsSmall = /run(?:s)? one size small/.test(p.text) && p.fit !== 'oversized';
    const candidates = check.sizes.map((size, index) => {
      const row = chart[size];
      const c = row[main];
      const measure = circumference(c);
      const max = c.max * (c.half ? 2 : 1);
      const ease = measure - body;
      let reason = null;
      if (input.maxLength && row.length.max > input.maxLength + 0.1) reason = 'length';
      if (!input.maxLength && longCoat && row.length.max > input.height * 0.78) reason = 'length_estimate';
      if (p.bottom && p.flexibleWaist && c.min === c.max && body > measure) reason ||= 'stretch_unknown';
      else if (p.bottom && p.flexibleWaist && max >= body && c.min !== c.max) {
        if (measured && body < measure - 6) reason ||= 'loose';
      } else if (ease < minimum - (measured ? 0 : 6)) reason ||= p.stretch ? 'stretch_unknown' : measured ? 'tight' : 'body_estimate';
      if (measured && p.bottom && !p.flexibleWaist && ease > 8) reason ||= 'loose';
      if (p.bottom && input.hip && row.hip && circumference(row.hip) < input.hip + 4) reason ||= p.stretch ? 'stretch_unknown' : 'hip';
      for (const field of ['waist', 'hip']) {
        if (field === main || input[field] == null || !row[field]) continue;
        const requiredEase = field === 'hip' ? 4 : 0;
        if (circumference(row[field]) < input[field] + requiredEase) reason ||= p.stretch ? 'stretch_unknown' : field;
      }
      const nominal = Math.abs(order.indexOf(size) - (reference.position + (!measured && runsSmall ? 1 : 0)));
      const primary = measured ? Math.abs(ease - target) : 0;
      const auxiliary = measured ? Math.abs(ease - (target + preference * 8)) : Math.abs(order.indexOf(size) - (auxiliaryPosition + (runsSmall ? 1 : 0)));
      let score = measured ? 0 : nominal * 4 + Math.abs(ease - target) * 0.08;
      if (longCoat && !input.maxLength) score += Math.max(0, row.length.min / input.height - 0.70) * 60;
      const shoulder = row.shoulder?.min;
      const sleeve = row.sleeve?.min;
      const reach = row.shoulderSleeve?.min || (shoulder && sleeve ? shoulder / 2 + sleeve : null);
      if (longCoat && reach) score += Math.max(0, reach - input.height * 0.52) * 0.4;
      return { size, index, score, primary, auxiliary, reason, length: row.length.min, measure, ease, sleeve, reach };
    });
    const safe = candidates.filter(c => !c.reason).sort((a, b) => a.score - b.score || a.index - b.index);
    if (!safe.length) {
      const uncertain = candidates.some(c => ['stretch_unknown','length_estimate','body_estimate'].includes(c.reason));
      return fail(uncertain ? 'review' : 'no_match', uncertain ? 'estimate_review' : 'no_match');
    }
    let eligible = safe;
    if (measured) {
      const bestPrimary = Math.min(...eligible.map(c => c.primary));
      eligible = eligible.filter(c => c.primary <= bestPrimary + 2);
    }
    const bestBase = Math.min(...eligible.map(c => c.score));
    eligible = eligible.filter(c => c.score <= bestBase + (measured ? 0.5 : 0.9));
    eligible.sort((a, b) => a.auxiliary - b.auxiliary || a.primary - b.primary || a.score - b.score || a.index - b.index);
    let first = eligible[0];
    if (measured && runsSmall) {
      const next = candidates.find(c => c.index === first.index + 1 && !c.reason);
      if (!next) return fail('review', 'small_fit_review');
      first = next;
    }
    return { status: 'match', sizes: [first.size], fit: p.fit, length: first.length, measure: first.measure, main, runsSmall, long, longCoat,
      estimated: !measured, lengthEstimated: longCoat && !input.maxLength, sleeve: first.sleeve,
      sleeveUnverified: longCoat, unverifiedHip: p.bottom && (!input.hip || !chart[first.size].hip), approximate: true };
  }
  const engine = { version: '2026-09-22.4', normalizeChartBasis, normalizeSize, richText, fieldName, parseCell, parseChart, profile, audit, recommend, circumference, referenceSize };
  if (typeof module !== 'undefined' && module.exports) module.exports = engine;
  else root.SthSizeCheckEngine = engine;
})(typeof window !== 'undefined' ? window : this);

